import React, {useState} from 'react';
import Modal from "../../components/modal/modal";
import {COURSE_ACCESS_CLASS_CODE} from "../../lib/constant";

const InviteModal = ({url, clazzCourseId, clazzCode, access, onClose}) => {
    return (
        <Modal
            title={window.L("teach.course.inviteToJoin")}
            tips={window.L("teach.course.inviteToJoinTips")}
            onClose={onClose}
            >
            <div style={{marginTop: "1rem"}}>
                <p style={{backgroundColor: "#efefef", padding: "1rem"}}>
                    课程ID：{clazzCourseId}<br/><br/>
                    {access == COURSE_ACCESS_CLASS_CODE && (<span>{window.L("teach.clazz.codeNeeded")}：{clazzCode}</span>)}<br/><br/>
                    方法1：登录后点击导航栏『加入班级』，输入课程ID：{clazzCourseId}，进入报名页。<br/><br/>
                    方法2：直接访问报名页链接：<br/>{url}<br/>
                </p>
            </div>


        </Modal>
    );
}

export default InviteModal;
